import React, { useEffect, useState } from "react";
import UsersStyle from "./style";
import TabsList from "../../Reusable/Tabs";
import { Button, Col, Input, Row, Table, Form, Popover, Skeleton } from "antd";
import {
  SearchOutlined,
  LeftOutlined,
  PlusOutlined,
  UserDeleteOutlined,
} from "@ant-design/icons";
import COLORS from "../../../common/Colors";
import DevelopmentImg from "../../../assets/Icons/development-img.png";
import PaymentWarningImg from "../../../assets/Images/Payment_Warning.png";
import FileWarningImg from "../../../assets/Images/file_upload_image.png";
import BranchWarningImg from "../../../assets/Images/branch_image.png";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { setEditUserData } from "../../../Redux/systemSlice";
import { useDispatch, useSelector } from "react-redux";
import UserInfo from "./Info";

const StyledTable = styled(Table)`
  padding-top: 20px;
  table {
    width: 100% !important;
  }
  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
    border: 1px solid #00000024;
    border-radius: 10px;
  }
  .ant-table-cell {
    padding: 20px;
  }
  .normal-column {
    min-width: 300px;
    white-space: normal;
  }
  .ant-table-thead .ant-table-cell {
    font-weight: 600;
    font-size: 0.9rem;
    color: ${COLORS.SECONDARY_BLACK};
    white-space: nowrap;
  }
  .non-white {
    background: #f9f9f9;
  }
  .ant-table-thead > tr > th::before {
    display: none !important;
  }

  .ant-table-cell-row-hover {
    background: #e3e8fc !important;
  }
`;

const StyledImg = styled.img`
  cursor: pointer;
`;

const ViewUsers = ({ tableViewData, setUserRenderView, clickEditTableIcon }) => {
  const [activeTab, setActiveTab] = useState("1");
  const addGroupData = useSelector(
    (state) => state.systemTracking.addGroupData
  );
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const navigate = useNavigate();
  const diapatch = useDispatch();

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if(clickEditTableIcon){
      setActiveTab("6")
    }
  }, [clickEditTableIcon])

  // Simulate loading with a timeout
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);


  const hanldeClickEdit = () => {};

  const columns1 = [
    {
      title: "Course",
      dataIndex: "course",
      key: "course",
      sorter: (a, b) => a.user - b.user,
    },
    {
      title: "Code",
      dataIndex: "code",
      key: "code",
    },
    {
      title: "Role",
      dataIndex: "role",
      key: "role",
    },
    {
      title: "Enrolled Date",
      dataIndex: "enrolledDate",
      key: "enrolledDate",
    },
    {
      title: "Completion Date",
      dataIndex: "completeDate",
      key: "completeDate",
    },
    {
      title: "",
      dataIndex: "edit",
      key: "edit",
      width: "7%",
      render: (text, record) => {
        return (
          <Popover placement="top" content="Unenroll">
            <UserDeleteOutlined
              className="user-remove-icon"
              onClick={(e) => {
                e.stopPropagation();
                hanldeClickEdit(record);
              }} // Replace with your download function
            />
          </Popover>
        );
      },
    },
  ];

  const dataSource1 = [
    {
      key: 1,
      course: "What is TalentLibrary?",
      code: "002",
      role: "Instructor",
      enrolledDate: "17-10-2024",
      completeDate: "12min ago",
    },
  ];

  const onSelectChange = (newSelectedRowKeys) => {
    console.log("selectedRowKeys changed: ", newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const onChangeSortedTable = (pagination, filters, sorter, extra) => {
    console.log("params", pagination, filters, sorter, extra);
  };

  const handleClickData = () => {
    setUserRenderView("view-table");
  };
  const items = [
    {
      id: "1",
      label: "Course",
      component: <></>,
    },
    {
      id: "2",
      label: "Groups",
      component: <></>,
    },
    {
      id: "3",
      label: "Branches",
      component: <></>,
    },
    {
      id: "4",
      label: "Payments",
      component: <></>,
    },
    {
      id: "5",
      label: "Files",
      component: <></>,
    },
    {
      id: "6",
      label: "Info",
      component: <></>,
    },
  ];

  const handleTabSelect = (key) => {
    setActiveTab(key);
  };

  const handleBack = () => {
    setUserRenderView("table-view");
  };

  const handleClickEdit = (data) => {
    diapatch(setEditUserData(data));
    setActiveTab("6")
  };

  const columns4 = [
    {
      title: "Group",
      dataIndex: "group",
      key: "group",
    },
    {
      title: "Group courses",
      dataIndex: "groupCourse",
      key: "groupCourse",
    },
    {
      title: "",
      dataIndex: "add",
      key: "add",
      width: "7%",
      render: (text, record) => {
        return (
          <Popover placement="top" content="Remove user from group">
            <UserDeleteOutlined
              className="user-remove-icon"
              onClick={(e) => {
                e.stopPropagation();
                // hanldeClickRemoveGroup(record);
              }}
            />
          </Popover>
        );
      },
    },
  ];

  const groupNameList = addGroupData.map((item) => ({
    group: item.group,
    key: item.groupId,
  }));

  return (
    <>
      <UsersStyle>
        <div className="user-title-container users-menu-filter-container">
          <div>
            <LeftOutlined onClick={handleBack} />{" "}
            <span className="user-menu-title">{tableViewData.user}</span>
          </div>
          {!clickEditTableIcon && 
            <Button
              className="add-user-button"
              onClick={() => handleClickEdit(tableViewData)}
            >
              Edit User
            </Button>
          }
        </div>

        <TabsList
          items={items}
          handleTabSelect={handleTabSelect}
          activeKey={activeTab}
          tabId={activeTab}
        />

        {activeTab === "1" && (
          <>
            <Row className="users-menu-filter-container">
              <Col>
                <Form.Item name="search" className="search-input-field">
                  <Input prefix={<SearchOutlined />} placeholder="Search" />
                </Form.Item>
              </Col>

              <Col>
                <Button className="course-enroll-button">
                  <PlusOutlined /> Enroll to Course
                </Button>
              </Col>
            </Row>
            <StyledTable
              // rowSelection={rowSelection}
              dataSource={dataSource1}
              columns={columns1}
              rowClassName={(record, index) =>
                index % 2 === 0 ? "" : "non-white"
              }
              rowKey="checkin_id"
              id="Table"
              onChange={onChangeSortedTable}
              showSorterTooltip={{
                target: "sorter-icon",
              }}
              onRow={(record, rowIndex) => {
                return {
                  onClick: () => {
                    handleClickData();
                  },
                };
              }}
            />
          </>
        )}

        {activeTab === "2" && (
          <>
            {groupNameList.length > 0 ? (
              <>
                <StyledTable
                  dataSource={groupNameList}
                  columns={columns4}
                  rowClassName={(record, index) =>
                    index % 2 === 0 ? "" : "non-white"
                  }
                  rowKey="key"
                  id="Table"
                />
              </>
            ) : (
              <>
                <Row className="yet-designed-pages">
                  <img
                    src={DevelopmentImg}
                    alt={DevelopmentImg}
                    className="yet-designed-pages-image"
                    width={340}
                  />
                  <div className="yet-designed-pages">
                    <p className="developement-content">
                      There are no groups yet!
                    </p>
                    <span className="developement-span-content">
                      Groups allow you to assign sets of courses to several
                      users at once.
                    </span>
                    <Button
                      className="developement-add-button"
                      // onClick={showDrawer}
                    >
                      Add group
                    </Button>
                  </div>
                </Row>
              </>
            )}
          </>
        )}

        {activeTab === "3" && (
          <>
            <div>
              {loading ? <Skeleton.Image active={true} /> 
                : (
                  <img
                    width={300}
                    src={BranchWarningImg}
                    alt="Branch-Image"
                    className="yet-designed-pages-image"
                  />
                )
              }
              
              <div className="yet-designed-pages">
                <p className="developement-content">
                  There are no branches yet!
                </p>
                <span className="developement-span-content">
                  Separate audiences in independent sub-portals. They can have
                  their own courses, users, domain, and appearance.
                </span>
                <Button
                  className="developement-add-button"
                  // onClick={showDrawer}
                >
                  Add to branch
                </Button>
              </div>
            </div>
          </>
        )}

        {activeTab === "4" && (
          <>
            <div>
              {loading ? <Skeleton.Image active={true} /> 
                : (
                  <img
                    width={300}
                    src={PaymentWarningImg}
                    alt={PaymentWarningImg}
                    className="yet-designed-pages-image"
                  />
                )
              }
              
              <p className="developement-content">
                There are no invoices for this user!
              </p>
            </div>
          </>
        )}

        {activeTab === "5" && (
          <>
            <div>
              {loading ? <Skeleton.Image active={true} /> 
                : (
                  <img
                    width={300}
                    src={FileWarningImg}
                    alt={FileWarningImg}
                    className="yet-designed-pages-image"
                  />
                )
              }
          
              <div className="yet-designed-pages">
                <p className="developement-content">There are no files yet!</p>
                <span className="developement-span-content">
                  Start adding some.
                </span>
                <Button
                  className="developement-add-button"
                  // onClick={showDrawer}
                >
                  Upload files
                </Button>
              </div>
            </div>
          </>
        )}

        {activeTab === "6" && (
          <>
            <UserInfo />
          </>
        )}
      </UsersStyle>
    </>
  );
};

export default ViewUsers;
